import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import VehicleServices from "services/VehicleServices";
import { notifyError, notifySuccess } from "utils/toast";

const useVehicle = (id,vehicleReg,setVehicleReg ) => {
   
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedReferenceNo,setselectedReferenceNo]=useState('');
  const [exteriorUrl1, setExteriorUrl1] = useState('');
  const [exteriorUrl2, setExteriorUrl2] = useState('');
  const [interiorUrl2, setInteriorUrl2] = useState('');
  const [interiorUrl1, setInteriorUrl1] = useState('');
  

  const [regurl, setRegurl] = useState('');
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
     setError, 
    formState: { errors },
  } = useForm();
  const vehicleRegStr = vehicleReg?.join(" ") || ""; 
  
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      
      setIsSubmitting(true);
      // if ( !interiorUrl1) {
      //   notifyError("Interior 1 is required.");
      //   setIsSubmitting(false);
      //   return;  
      // }
   

      //  if ( !interiorUrl2) {
      //   notifyError("Interior 2 is required.");
      //   setIsSubmitting(false);
      //   return;  
      // }
      // if (!regurl) {
      //   notifyError("Registration Certificate is required.");
      //   setIsSubmitting(false);
      //   return;  
      // }
      // if ( !exteriorUrl1) {
      //   notifyError("Exterior 1 is required.");
      //   setIsSubmitting(false);
      //   return;  
      // }
      // if (  !exteriorUrl2) {
      //   notifyError("Exterior 2 is required.");
      //   setIsSubmitting(false);
      //   return;  
      // }
      const VehicleData = {
        vendor_id:selectedReferenceNo,
        vehicle_name_id:data.vehicle_name_id,
        vehicle_reg_no:vehicleRegStr,
        interior_img_1:interiorUrl1,
        interior_img_2:interiorUrl2,
        exterior_img_1:exteriorUrl1,
        exterior_img_2:exteriorUrl2,
        reg_cer_img:regurl,
        year_of_vehicle_manufactured: data.year_of_vehicle_manufactured
      };


      if (id) {
        const res = await VehicleServices.updateVehicle(id, VehicleData);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await VehicleServices.addVehicle( VehicleData );
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
      //closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };
  const getVehicleData = async () => {

    try {
      const res = await VehicleServices.getVehicleById(id);
      if (res) {
        setselectedReferenceNo(String(res.data.vendor_id));

        setValue("year_of_vehicle_manufactured", res.data.year_of_vehicle_manufactured);
        setValue("vehicle_name_id", res.data.vehicle_name_id);
      //  const vehicleRegArray = res.data.vehicle_reg_no ? res.data.vehicle_reg_no.split(",") : [];
      //   setVehicleReg(vehicleRegArray);
      const vehicleRegArray =  res.data.vehicle_reg_no.split(" ");  
setVehicleReg(vehicleRegArray); 
        // const vehicleRegStr = res.data.vehicle_reg_no || ""; // Fallback to empty string if undefined
        // const vehicleRegArray = vehicleRegStr.match(/^([A-Z]{2})([0-9]{2})([A-Z]{1,2})([0-9]{4})$/)?.slice(1) || [];
        // setVehicleReg(vehicleRegArray);
        setExteriorUrl1(res.data.exterior_img_1);
        setExteriorUrl2(res.data.exterior_img_2);
        setInteriorUrl1(res.data.interior_img_1);
        setInteriorUrl2(res.data.interior_img_2);
        setRegurl(res.data.reg_cer_img);
        
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setValue("vendor_id");
      setValue("vehicle_name_id");
      setVehicleReg(["", "", "", ""]);
      setValue("vehicle_reg_no", "");
 
      setselectedReferenceNo('');
      setValue("year_of_vehicle_manufactured");
      setExteriorUrl1('');
      setExteriorUrl2('');
      setInteriorUrl1('');
      setInteriorUrl2('');
     // setVehicleReg('');
      setRegurl('');
    
      clearErrors();
      return;
    }
      
    if (id) {
      getVehicleData();
    }
    // eslint-disable-next-line
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,setValue,
    errors,loading,setLoading,
    isSubmitting,setError,clearErrors,
    selectedReferenceNo,setselectedReferenceNo,
    interiorUrl1, setInteriorUrl1,interiorUrl2, setInteriorUrl2,exteriorUrl1, setExteriorUrl1,exteriorUrl2, setExteriorUrl2, regurl, setRegurl
  };
};  

export default useVehicle;
